import { Message } from '@twilio/conversations';
import ProjectLinks from 'src/app/common/project.links';
import { UserInfo } from 'src/app/interfaces';
import { AccountStatus } from 'src/app/swagger-api';
import { MessengerMessage, MessengerMessagesTypes } from '../../event-messenger/interfaces/messenger.interface';
import { ChatChannelType } from '../interfaces/chat-model.interface';
import { TwilioConversationAttributes } from '../services/twilio/twilio.interfaces';
import { computeConversationEffectiveTitle } from './twilio-message.helpers';

export function twilioToMessengerMessageAdapter(
  message: Message,
  messageAuthorInfo: UserInfo,
  conversationParticipants: UserInfo[],
  currentUserId: string,
): MessengerMessage {
  const conversationAttributes: TwilioConversationAttributes = message.conversation
    .attributes as TwilioConversationAttributes;

  const channelType: ChatChannelType = conversationAttributes.type || ChatChannelType.CONVERSATION;

  const channelFriendlyName: string = computeConversationEffectiveTitle(
    message.conversation.friendlyName,
    conversationParticipants,
    currentUserId,
  );

  return {
    channelType,
    messageAuthor: messageAuthorInfo,
    conversationParticipants,
    messageType: getMessengerMessageType(),
    channelLink: createChannelLink(conversationAttributes),
    senderLink: createSenderLink(messageAuthorInfo),
    isChannelUnread:
      messageAuthorInfo.userId !== currentUserId &&
      (message.conversation.lastReadMessageIndex === null || message.conversation.lastReadMessageIndex < message.index),
    isGroupMessage: isGroupConversationForMessenger(conversationParticipants),
    messageBody: message.body,
    channelFriendlyName,
    channelUniqueName: message.conversation.uniqueName,
    dateCreated: message.dateCreated,
  };
}

export function isGroupConversationForMessenger(conversationParticipants: UserInfo[]): boolean {
  return conversationParticipants.length > 2;
}

export function createSenderLink(messageAuthorInfo: UserInfo): string {
  if (messageAuthorInfo.userStatus === AccountStatus.ACTIVE) {
    return `${ProjectLinks.LINK_PROFILE_VIEW}/${messageAuthorInfo.userId}`;
  } else {
    return `${ProjectLinks.LINK_LOGIN}`;
  }
}

export function createChannelLink(conversationAttributes: TwilioConversationAttributes): string {
  if (conversationAttributes.channel_id) {
    if (conversationAttributes.type === ChatChannelType.CONVERSATION) {
      return `${ProjectLinks.LINK_CHAT}/${conversationAttributes.channel_id}`;
    }
  }
  return `${ProjectLinks.LINK_LOGIN}`;
}

export function getMessengerMessageType(): MessengerMessagesTypes {
  return MessengerMessagesTypes.text;
}
